var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"search-results-summary desktop-only"},[_c('ResultsSummary')],1),_c('div',{staticClass:"desktop-only"},[_c('FilterTags'),_c('ClearFilters')],1),_c('SearchResultsHeaderPWA'),_c('SearchResultsBodyPWA')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }